import React from "react";
import "./Getintouch.css";

const Getintouch = () => {
  return (
    <div id="MessageUs" className="getintouch">
      <div className="leftForm"></div>
      <div className="rightForm">
        <form action="https://formsubmit.co/ndfitnessclub@gmail.com" method="POST">
          <h2>Join us for your fitness goals: </h2>
          <input type="text" name="name" placeholder="Your Name" class="input" required></input>
          <br></br>
          <input
            type="text"
            name="Phone number"
            placeholder="Phone (optional)"
            class="input"
          ></input>
          <br></br>
          <input type="email" name="email" placeholder="Your email" class="input" required></input>
          <br></br>
          <textarea type="text" name="Message" placeholder="How can we help you..."></textarea>
          <input type="hidden" name="_template" value="table"></input>
          <br></br>

          <button className="blogBtn sendBtn">Send</button>
        </form>

        <div className="contactBtns">
          <a href="https://www.instagram.com/ndfitnessclub_rohtak/?hl=en" target="_blank">
          <button class="Btn">
            <span class="svgContainer">
              <svg
                fill="white"
                class="svgIcon"
                viewBox="0 0 448 512"
                height="1.5em"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path d="M224.1 141c-63.6 0-114.9 51.3-114.9 114.9s51.3 114.9 114.9 114.9S339 319.5 339 255.9 287.7 141 224.1 141zm0 189.6c-41.1 0-74.7-33.5-74.7-74.7s33.5-74.7 74.7-74.7 74.7 33.5 74.7 74.7-33.6 74.7-74.7 74.7zm146.4-194.3c0 14.9-12 26.8-26.8 26.8-14.9 0-26.8-12-26.8-26.8s12-26.8 26.8-26.8 26.8 12 26.8 26.8zm76.1 27.2c-1.7-35.9-9.9-67.7-36.2-93.9-26.2-26.2-58-34.4-93.9-36.2-37-2.1-147.9-2.1-184.9 0-35.8 1.7-67.6 9.9-93.9 36.1s-34.4 58-36.2 93.9c-2.1 37-2.1 147.9 0 184.9 1.7 35.9 9.9 67.7 36.2 93.9s58 34.4 93.9 36.2c37 2.1 147.9 2.1 184.9 0 35.9-1.7 67.7-9.9 93.9-36.2 26.2-26.2 34.4-58 36.2-93.9 2.1-37 2.1-147.8 0-184.8zM398.8 388c-7.8 19.6-22.9 34.7-42.6 42.6-29.5 11.7-99.5 9-132.1 9s-102.7 2.6-132.1-9c-19.6-7.8-34.7-22.9-42.6-42.6-11.7-29.5-9-99.5-9-132.1s-2.6-102.7 9-132.1c7.8-19.6 22.9-34.7 42.6-42.6 29.5-11.7 99.5-9 132.1-9s102.7-2.6 132.1 9c19.6 7.8 34.7 22.9 42.6 42.6 11.7 29.5 9 99.5 9 132.1s2.7 102.7-9 132.1z"></path>
              </svg>
            </span>
            <span class="BG"></span>
          </button>
          </a>

          <a href="https://www.youtube.com/@ndfitnessclub1242" target="_blank">
          <button class="yBtn">
            <span class="svgContainer">
              <svg
                viewBox="0 0 576 512"
                fill="white"
                height="1.6em"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path d="M549.7 124.1c-6.3-23.7-24.8-42.3-48.3-48.6C458.8 64 288 64 288 64S117.2 64 74.6 75.5c-23.5 6.3-42 24.9-48.3 48.6-11.4 42.9-11.4 132.3-11.4 132.3s0 89.4 11.4 132.3c6.3 23.7 24.8 41.5 48.3 47.8C117.2 448 288 448 288 448s170.8 0 213.4-11.5c23.5-6.3 42-24.2 48.3-47.8 11.4-42.9 11.4-132.3 11.4-132.3s0-89.4-11.4-132.3zm-317.5 213.5V175.2l142.7 81.2-142.7 81.2z"></path>
              </svg>
            </span>
            <span class="yBG"></span>
          </button>
          </a>
        </div>
      </div>
    </div>
  );
};

export default Getintouch;
